import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useRun(jobId, stage, onDone) {
  const [run, setRun] = useState(null);
  const timer = useRef(null);
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  const poll = useCallback((id) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const { data } = await api.get(`/runs/${id}`);
        setRun(data);
        if (data.status === "queued" || data.status === "running") poll(id);
        else {
          if (data.status === "done") toast.success("AI step finished");
          else toast.error(`Stage job failed: ${data.error}`);
          doneRef.current && doneRef.current(data);
        }
      } catch (e) { poll(id); }
    }, 2000);
  }, []);

  const track = useCallback(() => {
    api.get(`/jobs/${jobId}/runs`, { params: { stage } }).then(({ data }) => {
      const last = data[0];
      setRun(last || null);
      if (last && ["queued", "running"].includes(last.status)) poll(last.id);
    });
  }, [jobId, stage, poll]);

  useEffect(() => {
    track();
    return () => clearTimeout(timer.current);
  }, [track]);

  const start = async (action, params = {}) => {
    try {
      const { data } = await api.post(`/jobs/${jobId}/runs`, { action, params });
      setRun(data);
      toast.message("AI started. You can keep working");
      poll(data.id);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const busy = run && ["queued", "running"].includes(run.status);
  return { run, start, busy, track };
}
